import { render } from "./NewTag.vue?vue&type=template&id=d0b11836"
import script from "./NewTag.vue?vue&type=script&lang=js"
export * from "./NewTag.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__